module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-sidebar",
    class: {
      'kiwi-sidebar--wide': _vm.sidebarIsWide
    }
  }, [(_vm.buffer) ? [(_vm.buffer.isChannel()) ? [(_vm.sidebarIsWide) ? _c('span', {
    staticClass: "kiwi-sidebar-options",
    on: {
      "click": function($event) {
        _vm.sidebarIsWide = false
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('close')) + " "), _c('i', {
    staticClass: "fa fa-caret-right",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', {
    staticClass: "kiwi-sidebar-options",
    on: {
      "click": function($event) {
        _vm.settings_open = !_vm.settings_open
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cog",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('side_options')) + "\n            ")]), _vm._v(" "), (_vm.settings_open) ? _c('div', {
    staticClass: "kiwi-sidebar-buffersettings",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('tabbed-view', [_c('tabbed-tab', {
    attrs: {
      "header": _vm.$t('settings'),
      "focus": true
    }
  }, [_c('channel-info', {
    attrs: {
      "buffer": _vm.buffer
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "kiwi-sidebar-settings"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('side_settings')))]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingShowJoinParts),
      expression: "settingShowJoinParts"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingShowJoinParts) ? _vm._i(_vm.settingShowJoinParts, null) > -1 : (_vm.settingShowJoinParts)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.settingShowJoinParts,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingShowJoinParts = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.settingShowJoinParts = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settingShowJoinParts = $$c
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('side_joins')))]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingShowTopics),
      expression: "settingShowTopics"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingShowTopics) ? _vm._i(_vm.settingShowTopics, null) > -1 : (_vm.settingShowTopics)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.settingShowTopics,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingShowTopics = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.settingShowTopics = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settingShowTopics = $$c
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('side_topics')))]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingShowNickChanges),
      expression: "settingShowNickChanges"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingShowNickChanges) ? _vm._i(_vm.settingShowNickChanges, null) > -1 : (_vm.settingShowNickChanges)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.settingShowNickChanges,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingShowNickChanges = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.settingShowNickChanges = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settingShowNickChanges = $$c
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('side_nick_changes')))]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingShowModeChanges),
      expression: "settingShowModeChanges"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingShowModeChanges) ? _vm._i(_vm.settingShowModeChanges, null) > -1 : (_vm.settingShowModeChanges)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.settingShowModeChanges,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingShowModeChanges = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.settingShowModeChanges = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settingShowModeChanges = $$c
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('side_mode_changes')))]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingExtraFormatting),
      expression: "settingExtraFormatting"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingExtraFormatting) ? _vm._i(_vm.settingExtraFormatting, null) > -1 : (_vm.settingExtraFormatting)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.settingExtraFormatting,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingExtraFormatting = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.settingExtraFormatting = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settingExtraFormatting = $$c
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('side_formatting')))]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingColouredNicklist),
      expression: "settingColouredNicklist"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingColouredNicklist) ? _vm._i(_vm.settingColouredNicklist, null) > -1 : (_vm.settingColouredNicklist)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.settingColouredNicklist,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingColouredNicklist = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.settingColouredNicklist = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settingColouredNicklist = $$c
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('side_colours')))])])], 1), _vm._v(" "), _c('tabbed-tab', {
    attrs: {
      "header": _vm.$t('banned')
    }
  }, [_c('channel-banlist', {
    attrs: {
      "buffer": _vm.buffer
    }
  })], 1), _vm._v(" "), _c('tabbed-tab', {
    attrs: {
      "header": _vm.$t('notifications')
    }
  }, [_c('buffer-settings', {
    attrs: {
      "buffer": _vm.buffer
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.userbox_user) ? _c('div', {
    staticClass: "kiwi-sidebar-userbox",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('user-box', {
    attrs: {
      "user": _vm.userbox_user,
      "buffer": _vm.buffer,
      "network": _vm.network
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.buffer.isChannel()) ? _c('nicklist', {
    attrs: {
      "network": _vm.network,
      "buffer": _vm.buffer,
      "users": _vm.users
    }
  }) : _vm._e()] : (_vm.buffer.isQuery()) ? void 0 : _vm._e()] : [_vm._v("\n        " + _vm._s(_vm.$t('side_buffer')) + "\n    ")]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7adb563e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 496
// module chunks = 2